export default __webpack_public_path__ + "static/media/notification-admin.902dbe25.mp3";